module.exports = __webpack_public_path__ + "images/thumbs-up_olddcaba741463aefdf016d7da7fdaa0650.svg";